import { useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { Save, Eye, Globe, Undo2 } from 'lucide-react';
import { toast } from 'sonner';
import { salvarRascunho, publicarHome, cancelarRascunho } from './homeApi';

export default function HomeActions({ cfg, temAlteracoes, onMudanca }) {
  const qc = useQueryClient();
  const [ocupado, setOcupado] = useState('');

  const invalidar = () => {
    qc.invalidateQueries({ queryKey: ['admin-home'] });
    qc.invalidateQueries({ queryKey: ['home'] });
    qc.invalidateQueries({ queryKey: ['admin-dashboard'] });
  };

  const acao = async (tipo, fn) => {
    setOcupado(tipo);
    const ok = await fn();
    setOcupado('');
    if (ok) {
      invalidar();
      onMudanca?.();
    }
  };

  const cancelar = async () => {
    if (!window.confirm('Descartar todas as alterações do rascunho e voltar à versão publicada?')) return;
    await acao('cancelar', cancelarRascunho);
  };

  return (
    <div className="sticky bottom-3 z-20 mt-6 flex flex-wrap items-center gap-2 rounded-2xl border border-slate-200 bg-white/95 p-3 shadow-xl backdrop-blur">
      {temAlteracoes && (
        <span data-testid="home-draft-badge" className="mr-1 rounded-full bg-amber-100 px-3 py-1 text-[11px] font-extrabold uppercase tracking-wide text-amber-700">
          Rascunho com alterações não publicadas
        </span>
      )}
      <button
        data-testid="home-save-draft"
        disabled={Boolean(ocupado)}
        onClick={() => acao('rascunho', () => salvarRascunho(cfg))}
        className="inline-flex items-center gap-2 rounded-full border-2 border-mk-blue px-4 py-2.5 text-sm font-bold text-mk-blue hover:bg-blue-50 disabled:opacity-50"
      >
        <Save size={15} /> {ocupado === 'rascunho' ? 'Salvando...' : 'Salvar rascunho'}
      </button>
      <button
        data-testid="home-preview"
        onClick={async () => {
          const ok = await salvarRascunho(cfg);
          if (ok) { invalidar(); window.open('/?previa=1', '_blank'); }
          else toast.error('Salve o rascunho antes de visualizar.');
        }}
        className="inline-flex items-center gap-2 rounded-full border-2 border-slate-300 px-4 py-2.5 text-sm font-bold text-slate-600 hover:bg-slate-50"
      >
        <Eye size={15} /> Visualizar prévia
      </button>
      <button
        data-testid="home-publish"
        disabled={Boolean(ocupado)}
        onClick={() => acao('publicar', async () => (await salvarRascunho(cfg)) && (await publicarHome()))}
        className="inline-flex items-center gap-2 rounded-full bg-mk-red px-5 py-2.5 text-sm font-bold text-white shadow-md hover:bg-mk-redbright disabled:opacity-50"
      >
        <Globe size={15} /> {ocupado === 'publicar' ? 'Publicando...' : 'Publicar alterações'}
      </button>
      {temAlteracoes && (
        <button
          data-testid="home-discard"
          disabled={Boolean(ocupado)}
          onClick={cancelar}
          className="inline-flex items-center gap-2 rounded-full px-4 py-2.5 text-sm font-bold text-slate-500 hover:bg-slate-100"
        >
          <Undo2 size={15} /> Cancelar alterações
        </button>
      )}
    </div>
  );
}
